import { WhatsNewResponse } from "Types";

export const hasSeenThisRelease = (
  data: WhatsNewResponse,
  release: number[],
): boolean => {
  if (!data.last_seen_release) return false;

  const [checkMajor, checkMinor, checkPatch] = release;
  const [seenMajor, seenMinor, seenPatch] = data.last_seen_release
    .split(".")
    .map((item) => parseInt(item));

  if (seenMajor === checkMajor && seenMinor === checkMinor) {
    return seenPatch >= checkPatch;
  } else if (seenMajor === checkMajor) {
    return seenMinor >= checkMinor;
  } else {
    return seenMajor >= checkMajor;
  }
};
